import { css, type SerializedStyles, type Theme } from '@emotion/react';

import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';

import type { IconProps } from '../Icon';
import type { TooltipProps } from '../Tooltip';

type InfoIconWithTooltipProps = Omit<TooltipProps, 'children'> & {
  iconSize?: IconProps['size'];
};

const iconStyles = (theme: Theme): SerializedStyles => css`
  color: ${theme.palette.colors.gray[400]};
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;

export const InfoIconWithTooltip = ({
  iconSize = 'lg',
  ...props
}: InfoIconWithTooltipProps): JSX.Element => {
  return (
    <Tooltip {...props}>
      <Icon type="info-outlined" css={iconStyles as any} size={iconSize} />
    </Tooltip>
  );
};
